import { JSX } from 'react'
import { useFormikContext } from 'formik'

import { useScannersConnectionsSelection } from 'src/hooks'

import { IImpactForm, IStepForm } from 'src/types'
import { ScannersAssociations } from './association'

interface IProps<T> {
  isDisabled?: boolean
  description: string | JSX.Element
}

export const ScannersAssociationInput = <T extends IStepForm | IImpactForm>({
  isDisabled,
  description,
}: IProps<T>) => {
  const { values, setFieldValue } = useFormikContext<T>()
  const setSelectedScanners = (ids: string[]) => setFieldValue('selectedScanners', ids)
  const { handleSelectedScanner, selectedScannersConnections } = useScannersConnectionsSelection(
    values.selectedScanners,
    setSelectedScanners,
  )

  return (
    <ScannersAssociations
      isDisabled={isDisabled}
      setSelectedItems={setSelectedScanners}
      description={description}
      selectedItems={values.selectedScanners}
      handleSelectItem={handleSelectedScanner}
      connections={selectedScannersConnections}
    />
  )
}
